<template>
  <v-select
    :items="langs"
    v-model="langModel"
    :label="$t('language') | cap"
    menu-props="auto"
    prepend-icon="translate"
    hide-details
    return-object
    @input="$emit('update:lang', langModel.value)"
  >
  </v-select>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    lang: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      langModel: '',
      langs: [
        { text: 'Français', value: 'fr' },
        { text: 'English', value: 'en' },
        { text: 'Español', value: 'es' }
      ]
    }
  },

  watch: {
    langModel (val, oldVal) {
      this.$emit('change', val.value)
      this.$validator.localize(val.value)
    }
  },

  mounted () {
    let language =
      this.lang ||
      (this.$store.state._User.lang ||
      this.$i18n.locale) // pour la page login (quand déconnecté)
    // initialisation de la langue du composant
    this.langModel = _.find(this.langs, {value: language})
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSwitchLang.vue